import React from 'react';
import BaseType from './BaseType';
import './Typography.less';
export function BodyText(props) {
    return React.createElement(BaseType, Object.assign({ baseClass: 'kal-body-text' }, props));
}
export function BodyTextSmall(props) {
    return React.createElement(BaseType, Object.assign({ baseClass: 'kal-body-text-small' }, props));
}
export function Heading1(props) {
    return React.createElement(BaseType, Object.assign({ Component: 'h1', baseClass: 'kal-heading-1' }, props));
}
export function Heading2(props) {
    return React.createElement(BaseType, Object.assign({ Component: 'h2', baseClass: 'kal-heading-2' }, props));
}
export function Heading3(props) {
    return React.createElement(BaseType, Object.assign({ Component: 'h3', baseClass: 'kal-heading-3' }, props));
}
export function Heading4(props) {
    return React.createElement(BaseType, Object.assign({ Component: 'h4', baseClass: 'kal-heading-4' }, props));
}
export function Label(props) {
    return React.createElement(BaseType, Object.assign({ Component: 'label', baseClass: 'kal-label' }, props));
}
//# sourceMappingURL=Typography.js.map